<template>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>我的收藏</span>
      </div>
      <div class="myColl">
            <div class="headerBut">
                <div class="elinput">
                    <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select" v-if="inpu">
                            <el-button slot="append" @click="searchto" style="border-top:1px solid #DCDFE6;"><i><img src="../../../assets/images/portal/magnifier.png" alt=""></i></el-button>
                            <el-button slot="append" icon="el-icon-refresh-left" @click="Rescreening" style="border-left:1px solid #DCDFE6;"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="noshow" v-if="true">
                <span>快去添加实验吧</span>
                <p><img src="../../../assets/images/portal/noex.png" alt=""></p>
            </div>
          </div>
      </div>
    </el-card>
</template>

<script>
import request from '@/utils/request'

export default {
      data(){
        return{
            //搜索框
            search: '',
            inpu:true,
        }
      },
      methods:{
        // 搜索框
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList2();
        },
        Rescreening(){
            this.$confirm('此操作将会清除输入框内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'messageBox-prompt-test',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList()
            }).catch(() => {      
            });
        },
      }
}
</script>

<style scoped>
    .myColl{
        float: left;
        width: 100%;
        height: 100%;
    }
    /* 搜索框 */
    .elinput{
        float: right;
        width: auto;
    }
    .elinput /deep/ .el-input--suffix .el-input__inner{
        font-size: 16px;
        color: #a0a0a0;
        background-color: #f6f6f6;
    }
    .elinput /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
    .elinput /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 130px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 150px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    .el-input{
        width: 360px;
    }
    .el-card /deep/ .el-card__body{
      height: 770px;
    }
    .headerBut{
        float: left;
        width: 100%;
        padding: 20px 20px 0 20px;
        margin-bottom: 16px;
    }
</style>

<style rel="stylesheet/scss" lang="scss">
    .messageBox-prompt-test .el-button--primary{
        background-color:#f1ad4e;
        border-color:#f1ad4e;
    }
    .messageBox-prompt-test .el-button--default:hover{
        background-color:rgba($color: #f1ad4e, $alpha: 0.2);
        border-color:rgba($color: #f1ad4e, $alpha: 0.2);
        color: #f1ad4e;
    }
</style>


// WEBPACK FOOTER //
// src/views/layout/simple/simple2.vue